import React, { createContext, useState } from 'react';

export const AuthContext = createContext(null);

const AuthProvider = (props) => {
  const [isLoggedIn, setIsLoggedIn] =  useState(
    !localStorage.getItem("isLoggedIn")? false : JSON.parse(localStorage.getItem("isLoggedIn"))
  );   
  const login = () => {setIsLoggedIn(true); localStorage.setItem("isLoggedIn", "true");}
  const logout = () => {
    let result = window.confirm("Do you want to log out of the current session?");
    if (result) {
      setIsLoggedIn(false);
      localStorage.clear(); 
      window.location.href = '/s4l/login';
    }    
  }

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthProvider